import { Badge } from "../ui/badge";
import { getFilterButtonClass, getFilterTextClass, getCardClass, getDealsFilterBadgeClass } from "../../lib/styleHelpers";

const STATUS_CONFIG = {
  all: { label: "All", icon: null },
  watching: { label: "Watching", icon: "Eye" },
  executed: { label: "Executed", icon: "CheckCircle" },
  passed: { label: "Passed", icon: "X" },
  not_acted: { label: "Not Acted", icon: "Clock" },
};

export function DealsFilterBar({
  statusFilter,
  setStatusFilter,
  categoryFilter,
  setCategoryFilter,
  search,
  setSearch,
  categories,
  statusCounts,
  isDark,
}) {
  return (
    <div className={`rounded-xl p-4 border space-y-3 ${getCardClass(isDark)}`} data-testid="deals-filters">
      {/* Status filters */}
      <div className="flex flex-wrap gap-2">
        {Object.entries(STATUS_CONFIG).map(([key, cfg]) => {
          const isActive = statusFilter === key;
          return (
            <button
              key={key}
              onClick={() => setStatusFilter(key)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-medium transition-all ${getFilterButtonClass(isActive, isDark)}`}
              data-testid={`deals-filter-${key}`}
            >
              <span className={getFilterTextClass(isActive, isDark)}>{cfg.label}</span>
              <Badge variant="outline" className={`text-[10px] ml-1 ${getDealsFilterBadgeClass(isActive, isDark)}`}>
                {statusCounts[key] || 0}
              </Badge>
            </button>
          );
        })}
      </div>

      {/* Search + Category */}
      <div className="flex gap-2">
        <input
          type="text"
          placeholder="Search deals..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className={`flex-1 px-3 py-2 rounded-lg border text-sm focus:outline-none focus:ring-1 focus:ring-purple-500 ${isDark ? "bg-[#0a0a14] border-white/10 text-white placeholder:text-gray-600" : "bg-gray-50 border-gray-200 text-gray-900 placeholder:text-gray-400"}`}
          data-testid="deals-search"
        />
        <select
          value={categoryFilter}
          onChange={(e) => setCategoryFilter(e.target.value)}
          className={`px-3 py-2 rounded-lg border text-sm focus:outline-none focus:ring-1 focus:ring-purple-500 ${isDark ? "bg-[#0a0a14] border-white/10 text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
          data-testid="deals-category-filter"
        >
          <option value="all">All Categories</option>
          {categories.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
